var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zen-button',{attrs:{"to":_vm.link,"variant":_vm.variant,"disabled":_vm.disabled,"size":"sm"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }